import React, { Component } from 'react';
import { message } from "antd";
import Income from "./Income";
import Compared from "./Compared";
import moment from "moment";
import "./index.scss";

class index extends Component {


    // componentDidMount() {
    //     this.fetchAll();
    // }

    // fetchAll = async () => {
    //     try {
    //         const year = moment().format('YYYY');
    //         const month = moment().subtract(1, 'month').format('M');

    //         let j = await fetch(`/performanceReview?year=${year}&month=${month}`, { credentials: 'include' });
    //         let res = await j.json();
    //         console.log(res);
    //         this.setState({
    //             data: res.data || {}
    //         });
    //     } catch (error) {
    //         console.error(error);
    //         message.error('获取数据失败！');
    //     }
    // }

    render() {
        return (
            <div className="performanceReview">
                <div className="title">1.4 Performance Review 2019上半年酒店经营情况回顾</div>
                <Income />
                <Compared />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceReview/index.js